"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleChangeDropdown = exports.handleChangeCheckbox = exports.handleChangeInput = void 0;
const handleChangeInput = (e, onChange) => {
    e.preventDefault();
    onChange(e);
};
exports.handleChangeInput = handleChangeInput;
const handleChangeCheckbox = (e, onChange) => {
    const { checked, name } = e.target;
    onChange(checked, name);
};
exports.handleChangeCheckbox = handleChangeCheckbox;
const handleChangeDropdown = (value, name, onChange) => {
    onChange(value, name);
};
exports.handleChangeDropdown = handleChangeDropdown;
//# sourceMappingURL=index.js.map